import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // sempre rola pro topo
    window.scrollTo(0, 0);

    // reativa animações
    const elements = document.querySelectorAll(
      ".from-right, .from-left, .from-bottom, .from-top"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));

    

    return () => {
      observer.disconnect();
    };
  }, [pathname]); // 🔑 dispara a cada troca de rota

  return null;
}
